import React from 'react';
import PropTypes from 'prop-types';

const AuthorsNameComponent = ({ author}) => {

  return <p className='mr-1 ml-1'>{ author?.title }</p>
};

AuthorsNameComponent.propTypes = {
  author: PropTypes.any,
};

export default AuthorsNameComponent;
